import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, { ReactElement } from 'react';

export enum DIVIDER_THICKNESS {
    THIN = '1px',
    REGULAR = '2px',
}

export enum OPACITY_PERCENT {
    OPACITY_00 = '00',
    OPACITY_70 = '70',
    OPACITY_100 = '100',
}

interface IDividerProps extends IPropsWithChildren{
    className?: string;
    'data-testid'?: string;
    thickness?: DIVIDER_THICKNESS;
    opacity?: string;
}

export function Divider (props: IDividerProps): ReactElement {
    const {
        thickness = DIVIDER_THICKNESS.THIN,
        opacity = OPACITY_PERCENT.OPACITY_70,
        className,
        'data-testid': dataTestId,
    }: IDividerProps = props;

    const classes: string = classNames({
        'h-px': thickness === DIVIDER_THICKNESS.THIN,
        'h-1/4': thickness === DIVIDER_THICKNESS.REGULAR,
    });

    return (<hr className={`${className} opacity-${opacity} ${classes}`} data-testid={dataTestId} />);
}
